const currency = Object.freeze({
  CURRENCY: "Currency",
});

export default currency;
